// extracted by mini-css-extract-plugin
export default {"Container":"EcosystemCard_Container__poI6p","Title":"EcosystemCard_Title__QOvWG"};